<div class="header" *ngIf="translationLoaded">
  <qai-inner-wrap class="header_inner">
  <div *ngIf="weightAverage?.weight; else noSkillWeight">
    <qai-score
      *ngIf="overallScoreWithOneSection === 'OBJECTIVES'; else regularCard"
      [direction]="'column'"
      [size]="'medium'"
      [attr.data-testId]="'objectiveScoreAverage'"
      [kind]="
        scoreCriteria === 0
          ? 'none'
          : weightAverage?.average! >= scoreCriteria
          ? 'pass'
          : 'fail'
      "
      [value]="weightAverage?.average + ''"
      [max]="'5'"
      [label]="'results.OUT_OF' | transloco"
      [border]="true"
    >
      <div
        qai-card-title
        qaiSlot="title"
        href="/"
        target="_blank"
        data-testId="objectiveScoreTitle"
      >
        {{'results.OBJECTIVES'| transloco}}
      </div>

      <button
        qai-link
        qaiSlot="link"
        (click)="dialog.showModal()"
        data-testId="trackObjectiveCalculations"
      >
        {{'results.SCORE_CALCULATION_QUESTION'| transloco}}
      </button>
    </qai-score>

    <dialog
      #dialog
      qai-dialog
      [heading]="'results.SCORE_CALCULATION_TITLE' | transloco"
      [attr.data-testId]="'objectiveCalculationDialog'"
    >
      {{'results.SINGLE_SCORE_EXPLANATION'| transloco}}
    </dialog>

    <ng-template #regularCard>
      <qai-score
        [description]="localeService.formatPercentage(weightAverage?.weight ?? 0, localeService.getDecimalPlaces(weightAverage?.weight ?? 0, 2)) + ' ' + ('results.OVERALL_SCORE_PERCENT' | transloco)"
        [value]="(weightAverage?.average | number : '1.1-2') ?? ''"
        [max]="'5'"
        [label]="'results.OUT_OF' | transloco"
        [attr.data-testId]="'objectiveScoreAverage'"
        [kind]="
          scoreCriteria === 0
            ? 'none'
            : weightAverage?.average! >= scoreCriteria
            ? 'pass'
            : 'fail'
        "
        [size]="'medium'"
        [border]="true"
        [direction]="'row'"
      >
        <div qai-card-title qaiSlot="title" data-testId="objectiveScoreTitle">
          {{'results.SECTION_SCORE'| transloco}}
        </div>
      </qai-score>
    </ng-template>
  </div>

  <ng-template #noSkillWeight>
    <div class="content">
      <h2 data-testId="objectiveNoSkillHeader">
        {{'results.ELEVATE_OBJECTIVES_TITLE'| transloco}}
      </h2>
      <p data-testId="objectiveNoSkillText">
        {{'results.OBJECTIVES_NOTE'| transloco}}
      </p>
    </div>
  </ng-template>

  <div class="button-wrapper">
    <button
      qai-button
      [kind]="'primary'"
      [size]="'large'"
      id="btn-practice"
      class="button-container"
      data-testId="practiceAgain"
      (click)="practiceAgain($event)"
      *ngIf="
        (practiceType !== 'CERTIFICATION' ||
        (remainingAttempts && remainingAttempts > 0)) &&
        assignmentStatus?.toLowerCase() !== AppConstants.CLOSED_ASSIGNMENT_STATUS &&
        !hideCallButton
      "
      [disabled]="isMaxAttemptsReached"
      [matTooltip]="isMaxAttemptsReached ? ('results.MAX_ATTEMPTS_REACHED' | transloco) : ''"
      matTooltipClass="tooltip-dark"
    >
      {{ getButtonText() }}
    </button>
  </div>
  </qai-inner-wrap>
</div>

<qai-inner-wrap class="body" *ngIf="translationLoaded">
  <div class="content">
    <div
      class="call-feedback-content"
      *ngIf="overallScoreWithOneSection === 'OBJECTIVES'"
    >
      <div class="call-feedback-header">
        <h2 data-testId="callFeedbackTitle">{{'results.CALL_FEEDBACK'| transloco}}</h2>
      </div>

      <qai-item-grid
        gap="24px"
        minItemWidth="280px"
        repeatCount="auto-fit"
        style="margin-bottom: 20px; margin-top: 20px"
      >
        <qai-result-card
          [title]="scoreOverall?.Strengths?.title || ('results.STRENGTHS'| transloco)"
          *ngIf="scoreOverall?.Strengths?.feedback"
          [attr.data-testId]="'strengthsFeedbackCard'"
        >
          <qai-glyph kind="person" qaiSlot="icon" />
          <ul *ngIf="scoreOverall?.Strengths">
            <li
              *ngFor="
                let strengths of scoreOverall?.Strengths?.feedback;
                let i = index
              "
              [attr.data-testid]="'strength-' + i"
            >
              <ng-container *ngIf="strengths | extractBold as parsed">
                <b>{{ parsed.boldText }}</b
                >{{ parsed.restText }}
              </ng-container>
            </li>
          </ul>
        </qai-result-card>

        <qai-result-card
          [title]="scoreOverall?.Opportunities?.title || ('results.OPPORTUNITIES'| transloco)"
          [attr.data-testId]="'opportunitiesFeedbackCard'"
        >
          <qai-glyph kind="mountains" qaiSlot="icon" />
          <ul *ngIf="scoreOverall?.Opportunities">
            <li
              *ngFor="
                let opportunities of scoreOverall?.Opportunities?.feedback;
                let i = index
              "
              [attr.data-testid]="'opportunities-' + i"
            >
              <ng-container *ngIf="opportunities | extractBold as parsed">
                <b>{{ parsed.boldText }}</b
                >{{ parsed.restText }}
              </ng-container>
            </li>
          </ul>
        </qai-result-card>
      </qai-item-grid>
    </div>

    <div
      class="skill-container"
      *ngFor="let objective of objectives; let i = index"
      id="{{ 'target-' + i }}"
      [attr.data-testid]="'objective-' + i"
    >
      <div class="skill-header">
        <div class="title" [attr.data-testid]="'objectiveTitle-' + i">
          {{ objective.title }}
        </div>
        <div
          class="badge"
          [ngClass]="{
            expert: objective.score >= 4 && objective.score <= 5,
            proficient: objective.score < 4 && objective.score > 2,
            developing: objective.score <= 2
          }"
          [attr.data-testid]="'objectiveScore-' + i"
        >
          {{ localeService.formatNumber(objective.score, localeService.getDecimalPlaces(objective.score)) }}/5
        </div>
      </div>
      <div class="feedback-container">
        <div class="feedback-body">
          <p
            class="feedback-description"
            [attr.data-testid]="'objectiveFeedback-' + i"
          >
            {{ objective.feedback }}
          </p>
        </div>
      </div>
      <div
        *ngFor="let example of objective.examples; let j = index"
        [attr.data-testid]="'objective-' + i + '-example-' + j"
      >
        <qai-item-grid
          gap="24px"
          minItemWidth="280px"
          repeatCount="auto-fit"
          style="margin-bottom: 20px"
        >
          <qai-result-card
            *ngIf="example.improved"
            [title]="'results.WHAT_WE_SUGGEST' | transloco"
            [attr.data-testid]="
              'objective-' + i + '-example-' + j + '-suggestion'
            "
          >
            <ul>
              <li
                [attr.data-testid]="
                  'objective-' + i + '-example-' + j + '-suggestion-item'
                "
              >
                {{ example.improved }}
              </li>
            </ul>
          </qai-result-card>
          <qai-result-card
            *ngIf="!example.improved && example.effect"
            [title]="'results.WHAT_WE_SUGGEST' | transloco"
            [attr.data-testid]="
              'objective-' + i + '-example-' + j + '-no-recommendation'
            "
          >
            <span
              >{{'results.NO_SPECIFIC_RECOMMENDATION'| transloco}}</span
            >
          </qai-result-card>
          <qai-result-card
            *ngIf="example.effect"
            [title]="'results.WHY' | transloco"
            [attr.data-testid]="'objective-' + i + '-example-' + j + '-reason'"
          >
            <ul>
              <li
                [attr.data-testid]="
                  'objective-' + i + '-example-' + j + '-reason-item'
                "
              >
                {{ example.effect }}
              </li>
            </ul>
          </qai-result-card>
          <qai-result-card
            *ngIf="example.improved && !example.effect"
            [title]="'results.WHY' | transloco"
            [attr.data-testid]="
              'objective-' + i + '-example-' + j + '-no-suggestion'
            "
          >
            <span
              >{{'results.NO_INSIGHTS_AVAILABLE'| transloco}}</span
            >
          </qai-result-card>
        </qai-item-grid>
      </div>
    </div>

    <div class="session-id">
      <div
        data-testId="sessionId"
        class="text"
        (click)="copyText()"
        [matMenuTriggerFor]="tooltipMenu"
      >
        {{'results.SESSION_ID' | transloco}} {{ practiceCallUuid }}
      </div>
    </div>
    <mat-menu
      #tooltipMenu="matMenu"
      yPosition="above"
      hasBackdrop="false"
      class="tooltip-copy-session-id"
    >
      <div>{{'results.SESSION_ID_COPIED' | transloco}}</div>
    </mat-menu>
  </div>
</qai-inner-wrap>
